module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu3.6929a4cd.png";